import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { TranslocoDirective } from '@ngneat/transloco';
import { LoyaltySubscription } from '../../../core/models/loyalty/loyalty-subscription.model';
import { LayoutService } from '../../../core/services/layout.service';
import { ModalName, ModalService } from '../../../core/services/modal.service';
import { PremiumService } from '../../../loyalty/premium/premium.service';
import { IconNameType } from '../../icons/icon-name-type.enum';
import { RoundIconComponent } from '../../round-icon/round-icon.component';

@Component({
  selector: 'cwo-plan-premium-multi',
  standalone: true,
  imports: [TranslocoDirective, RoundIconComponent],
  templateUrl: './plan-premium-multi.component.html',
  styleUrl: './plan-premium-multi.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanPremiumMultiComponent {
  private static nextId = 0;

  readonly idBase = `plan-premium-multi-${PlanPremiumMultiComponent.nextId++}`;
  private readonly premiumService = inject(PremiumService);
  private readonly modalService = inject(ModalService);
  readonly layoutService = inject(LayoutService);

  readonly IconNameType = IconNameType;

  readonly plans = input.required<LoyaltySubscription[]>();
  readonly selectedName = input<string | null>(null);
  readonly savingsHeadline = input<string>("");
  readonly planSelected = output<LoyaltySubscription>();

  readonly planViewModels = computed(() =>
    this.plans().map((plan) => {
      const name = plan.subscriptionName ?? plan.displayName ?? '';
      return {
        plan,
        name,
        displayName: plan.displayName || name,
        price: `$${((plan.monthlyPrice?.price ?? 0) / 100).toFixed(2)}`,
        perks: this.premiumService.perksForSubscription().get(name) ?? [],
      };
    }),
  );

  isSelected(vm: { name: string }): boolean {
    return this.selectedName() === vm.name;
  }

  selectPlan(vm: { plan: LoyaltySubscription; name: string }): void {
    if (this.isSelected(vm)) return;
    this.planSelected.emit(vm.plan);
  }

  closeModal(): void {
    this.modalService.closeModal(ModalName.PremiumPromo);
  }
}
